import { createAction } from "@reduxjs/toolkit";

const actionTypes = {
	getDocuments : createAction("getDocuments"),	
}

export default actionTypes;